import { IVec2, Vec2 } from "@base/math/Vec2";
import { ImageSource, ITexInfo } from "@biz/definitions/SunSailDefinitions";
import { TexInfo } from "@biz/items/TexInfo";

export const TexInfoReducer = {
  setTextureType(old: ITexInfo, type: ITexInfo["type"]): ITexInfo {
    if (old.type === type)
      return old;
    if (type === "image") {
      return {
        area: TexInfo.createTexArea(),
        ...old,
        type: "image",
      }
    } else {
      return {
        rotation: 0,
        scale: Vec2.from(1, 1),
        offset: Vec2.from(0, 0),
        ...old,
        type: "pattern",
      }
    }
  },
  setTextureRotation(old: ITexInfo, rotation: number): ITexInfo {
    if (old.type !== "pattern")
      return old;
    return {
      ...old,
      rotation
    }
  },
  setTextureOffset(old: ITexInfo, offset: IVec2): ITexInfo {
    if (old.type !== "pattern")
      return old;
    return {
      ...old,
      offset
    }
  },
  setTextureScale(old: ITexInfo, scale: IVec2): ITexInfo {
    if (old.type !== "pattern")
      return old;
    return {
      ...old,
      scale
    }
  },
  setTextureArea(old: ITexInfo, area: IVec2[]): ITexInfo {
    if (old.type !== "image")
      return old;
    return {
      ...old,
      area
    }
  },
  setTextureImage(old: ITexInfo, imageSource: ImageSource, normalSource?: ImageSource): ITexInfo {
    const oldType = old.image.type === "predefined" ? "pattern" : "image";
    const newType = imageSource.type === "predefined" ? "pattern" : "image";
    if (oldType !== newType)
      old = TexInfoReducer.setTextureType(old, newType);

    return {
      ...old,
      image: imageSource,
      normal: normalSource
    }
  }
}